import Spinner from "./ui/Spinner.jsx";
import styled from "styled-components";
import {Navigate} from "react-router-dom";
import {useUser} from "./hooks/useUser.js";


const FullPage = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
`;

function ProtectedRoute({ children, requiredRole }) {
  
  // Load the authenticated user
  const { isLoading, isAuthenticated, user } = useUser();
  
  // While loading, show a loading spinner
  if(isLoading) {
    return(
        <FullPage>
          <Spinner />
        </FullPage>);
  }

  // This UI guard complements server authorization; it cannot replace it.
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (requiredRole && user?.role !== requiredRole) {
    return <main className="p-8" role="alert"><h1>Access denied</h1><p>This page requires an administrator account.</p></main>;
  }
  return children;
}

export default ProtectedRoute;
